import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6834cbe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "bg-white shadow user-container d-flex flex-wrap py-3"
}
const _hoisted_5 = { class: "px-lg-2 position-relative item d-flex border-bottom align-content-center padding-info" }
const _hoisted_6 = { class: "my-auto pb-1 py-lg-3" }
const _hoisted_7 = { class: "d-flex justify-content-center overflow-hidden rounded-circle align-content-center" }
const _hoisted_8 = { class: "d-flex flex-column align-content-center justify-content-center ms-3 w-100" }
const _hoisted_9 = { class: "is-admin" }
const _hoisted_10 = {
  key: 0,
  class: "author text-white d-flex justify-content-center fw-bold fs-8 mb-2 align-items-center"
}
const _hoisted_11 = {
  key: 0,
  class: "fw-bold fs-7 mt-2 d-flex item-name"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

import Heading from '@/views/user/groups/components/Heading.vue'
import Avatar from '@/components/avatar/index.vue'

import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Submenu from '@/components/submenu/index.vue'
import { translate } from '@/languages/i18n'
import LeaveGroupModal from '@/views/user/groups/components/LeaveGroupModal.vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'
import { onMounted, computed, ref } from 'vue'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'
import { Modal } from 'bootstrap'
import { ACCOUNT_STORE } from '@/store/constants'
import { ReplayName } from '@/constants/common.ts'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
const listUserGroup = computed(() => store.getters[GROUPS_STORE.GETTERS.LIST_USER_GROUP])
const detailGroup = computed(() => store.getters[GROUPS_STORE.GETTERS.DETAIL_GROUPS])
const loadingDetail = computed(() => store.getters[GROUPS_STORE.GETTERS.LOADING_DETAIL])

const dataLeave = ref<string>('')
const loadingListUser = ref<boolean>(false)
const menu = [
  {
    title: translate('SN70leaveGroup'),
  },
]
onMounted(async () => {
  loadingListUser.value = true
  try {
    await store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_USER_GROUP, route?.params?.group_id)
    setTimeout(() => {
      loadingListUser.value = false
    }, 1000)
  } catch (error) {
    console.log(error)
    loadingListUser.value = false
  }
})
const ChangeLeave = (data: any) => {
  dataLeave.value = data
}

const modal = ref()
const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)

const handleShowUser = async (id, userID, userType) => {
  if (userType === 'community_admin') {
    return
  }

  modal.value = new Modal(document.getElementById(userType === 'alumni' ? 'editProfileModal' : 'profileUserModal'))
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id, userID, userType })
  if (showModal.value) {
    await modal.value?.show()
  }
}

const handleName = (profileDetail: any) => {
  if (profileDetail?.is_deleted_in_30_days === 0) {
    if (!profileDetail?.available) return profileDetail?.display_name + ' ' + '[一時停止]'
    return profileDetail?.display_name
  } else if (profileDetail?.is_deleted_in_30_days === 1) {
    return profileDetail?.display_name + ' ' + '[脱退済み]'
  } else {
    return '脱退済みユーザ'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Heading),
    (loadingListUser.value && !_unref(loadingDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!loadingListUser.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listUserGroup), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['col-lg-4 padding-box', _unref(listUserGroup)?.length === 1 ? 'w-100' : 'item-user']),
              key: item
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(Avatar, {
                      is_deleted_in_30_days: item?.is_deleted_in_30_days,
                      user_image_url: item?.avatar_url,
                      userType: item?.user_type
                    }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (item?.is_admin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(translate)('creator')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(UserAliasIcon, {
                    userType: item?.user_type
                  }, null, 8, ["userType"]),
                  (item?.user_type === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(item?.display_name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "fw-bold fs-7 mt-2 d-flex cursor-pointer item-name",
                        onClick: () => handleShowUser(_unref(route)?.params?.id, item?.user_id, item?.user_type === 1 ? 'employee' : 'alumni')
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item?.display_name), 1)
                      ], 8, _hoisted_12))
                ]),
                ((_unref(detailGroup)?.is_community_admin || _unref(detailGroup)?.status === 1) && !item?.is_admin)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "sub-menu-container position-absolute",
                      onClick: ($event: any) => (ChangeLeave(item))
                    }, [
                      _createVNode(Submenu, {
                        menu: menu,
                        dataBs: [['modal', '#leaveGroup']],
                        iconAppear: 'true'
                      })
                    ], 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(LeaveGroupModal, { data: dataLeave.value }, null, 8, ["data"]),
    _createVNode(PortfolioAlumni),
    _createVNode(PortfolioUser)
  ], 64))
}
}

})